import * as React from 'react';
import { getDateRangeInput, getRooms } from 'stores/adapters';
export function useFormInputs(hotelId, searchCriteria) {
  return React.useMemo(() => ({
    propertyId: String(hotelId),
    dateRange: searchCriteria ? getDateRangeInput(searchCriteria) : null,
    roomInput: searchCriteria ? getRooms(searchCriteria) : []
  }), [hotelId, searchCriteria === null || searchCriteria === void 0 ? void 0 : searchCriteria.startDate, searchCriteria === null || searchCriteria === void 0 ? void 0 : searchCriteria.endDate, searchCriteria === null || searchCriteria === void 0 ? void 0 : searchCriteria.rooms]);
}